import { defineComponent, ref } from 'vue';
import Button from '../../../button';
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'AddButton',
    inheritAttrs: false,
    props: {
        prefixCls: String,
        editable: { type: Object },
        locale: { type: Object, default: undefined },
    },
    setup(props, { expose, attrs }) {
        const domRef = ref();
        expose({
            domRef,
        });
        return () => {
            const { prefixCls, editable, locale } = props;
            if (!editable || editable.showAdd === false) {
                return null;
            }
            return (<Button ref={domRef} iconType={'gray'} class={`${prefixCls}-nav-add`} style={attrs.style} aria-label={locale?.addAriaLabel || 'Add tab'} onClick={editable.onAdd}>
          {editable.addIcon ? editable.addIcon() : '+'}
        </Button>);
        };
    },
});
